export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
        meta: {
            requiresNotAuth: true
        }
    },

    {
        path: '/signup',
        name: 'signup',
        component: () => import(/* webpackChunkName: "signup" */ '../views/Signup.vue'),
        meta: {
            requiresNotAuth: true
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPassword.vue'),
        meta: {
            requiresNotAuth: true
        }
    },
]

